import React from "react"
import { Box, InputBase, Typography } from "@mui/material"
import { alpha } from "@mui/material/styles"
import { useSignal } from "@preact/signals-react"
import { IconSeeker } from "@ui-seeker/core"

import { dsColorNew } from "@palette"


const Key = ({ children }) => <Box component="kbd" sx={{
	font: 'inherit', fontSize: 11, fontWeight: 500, color: dsColorNew.textMuted,
	px: 0.75, py: 0.1, borderRadius: '5px', backgroundColor: dsColorNew.white,
	border: `1px solid ${dsColorNew.grayBorder}`, borderBottomWidth: 2,
}}>{children}</Box>

// The table's search box. Same keys as the framework's: Enter searches, Escape clears and closes.
export default function AppTableSearch({ onSearch, onHide }) {
	const textSearch = useSignal("")

	const handleHide = () => {
		textSearch.value = ""
		onHide()
	}

	return <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, minHeight: 40 }}>
		<InputBase
			autoFocus
			placeholder="Search"
			value={textSearch.value}
			onChange={e => textSearch.value = e.target.value}
			onKeyPress={e => e.key === "Enter" && onSearch(textSearch.value)}
			onKeyUp={e => e.key === "Escape" && handleHide()}
			startAdornment={<IconSeeker icon="magnifying-glass" sx={{ fontSize: 14, color: dsColorNew.textSubtle, mr: 1.25 }}/>}
			sx={{
				flex: '1 1 auto', maxWidth: 460, height: 38, px: 1.5,
				fontSize: 14, color: dsColorNew.textTitle,
				borderRadius: '10px', border: `1px solid ${dsColorNew.grayBorder}`, backgroundColor: dsColorNew.filterInputBg,
				'&.Mui-focused': { borderColor: dsColorNew.appBlue, backgroundColor: dsColorNew.white, boxShadow: `0 0 0 3px ${alpha(dsColorNew.appBlue, 0.15)}` },
			}}
		/>
		<Typography component="span" sx={{ display: 'inline-flex', alignItems: 'center', gap: 0.75, fontSize: 12, color: dsColorNew.textSubtle, whiteSpace: 'nowrap' }}>
			<Key>Enter</Key> search <Key>Esc</Key> close
		</Typography>
	</Box>
}
